import {
  IElementCategory,
  ElementCategoryID,
} from '../../../models/element-categories.model';
import { ElementPropertyType } from '../../../models/element-property.model';
import { labourProductMap, LabourPropertyName, Role } from './labour.model';
import { ElementKind } from '../../../models/project.model';
import {
  getElementPropertySelectionByValue,
  getValueFromConditionalNodes,
  IConditionalNode,
} from '../../../helpers/conditional-nodes.helpers';
import { ProductID } from '../../../models/product.model';
import { sbefCodeProperty } from '../common-element-category-properties.model';
import { PIECES_QUANTITY_FACTORY } from '../../../models/element-quantities.model';

export const labourProductIds: IConditionalNode<ProductID> = {
  property: LabourPropertyName.Role,
  map: labourProductMap,
};

export const labour: IElementCategory = {
  id: ElementCategoryID.Labour,
  name: 'Labour',
  color: '#AC91CE',
  defaultSelectedQuantity: 'time',
  disableQuantitySelection: true,
  properties: [
    {
      name: LabourPropertyName.Role,
      type: ElementPropertyType.Select,
      count: Role.Labourer,
      options: Object.values(Role),
    },
    sbefCodeProperty,
  ],
  getQuantityProperties: () => ({
    time: {},
    pieces: { ...PIECES_QUANTITY_FACTORY },
  }),
  // `throwIfNotFound: false` + `undefined` return: a transient invalid Role
  // value (e.g. a stale option after the labourProductMap shrinks) would
  // otherwise crash the enrich pass. Returning `undefined` tells the caller
  // to skip enrichment so existing children survive (vs `[]` which would
  // strip them).
  getChildElements: (element) => {
    const productId = getValueFromConditionalNodes(
      element,
      [labourProductIds],
      false,
    );
    if (!productId) return undefined;
    return [
      {
        kind: ElementKind.Product,
        unit: 'hr',
        count: 'time',
        product_id: productId,
      },
    ];
  },

  getElementPropertySelectionByProductId: (productId: ProductID) =>
    getElementPropertySelectionByValue(productId, labourProductIds),
};
